import LayoutContainer from 'components/Common/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import TextButton from 'LuxKit/Button/TextButton'
import SolidSparklesIcon from 'LuxKit/Icons/solid/SolidSparklesIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { rem } from 'polished'
import * as React from 'react'
import styled from 'styled-components'
import TripLandingTheresMoreAnimatedBackground from 'tripPlanner/Tripkit/TripLandingTheresMoreAnimatedBackground'
import { FormattedMessage } from 'react-intl'
import { CHAT_TRIP_PLANNER_NEW_PATH } from 'tripPlanner/config'
const StyledSheet = styled(Sheet)`
  display: grid;
  grid-template: "content" 1fr / 1fr;
  position: relative;
  min-height: 100%;
  width: 100%;
`

const StyledTripLandingAnimatedBackground = styled(TripLandingTheresMoreAnimatedBackground)`
  grid-area: content;
  position: absolute;
  top: ${rem(-64)};
  inset-inline: 0;
  bottom: ${rem(-64)};
  z-index: 0;
`

const ContentContainer = styled.div`
  grid-area: content;
  position: relative;
  z-index: 1;
  min-height: 100%;
  width: 100%;
`
function TripLandingPageFooter() {
  return (
    <StyledSheet padding="64 0 64" paletteType="inverse" background="normal-background">
      <StyledTripLandingAnimatedBackground />
      <ContentContainer>
        <LayoutContainer>
          <Group direction="vertical" gap={24} horizontalAlign="center">
            <VerticalSpacer gap={8}>
              <Heading variant="heading2" align="center">
                <FormattedMessage
                  id="R422PfMypqAeKeiCOZ5V"
                  defaultMessage="Ready to discover your <i>next adventure</i>?"
                  description="Heading text for footer section asking if user is ready to discover next adventure"
                  values={{
                    i: (chunks: React.ReactNode) => <i key="italic">{chunks}</i>,
                  }}
                />
              </Heading>
              <BodyText variant="medium" align="center">
                <FormattedMessage
                  id="UTMlNXYf-Lpqvq_JQCvV"
                  defaultMessage="Begin your journey with our trip planner made with 💚 by travel lovers"
                  description="Description text for footer section about trip planner made by travel lovers"
                />
              </BodyText>
            </VerticalSpacer>
            <div>
              <TextButton kind="primary" size="large" startIcon={<SolidSparklesIcon />} shape="round" to={CHAT_TRIP_PLANNER_NEW_PATH}>
                <FormattedMessage
                  id="js-m2IDe4z5PTo2WA_BV"
                  defaultMessage="Start planning - It’s free"
                  description="Button text for starting trip planning in the trip planner feature"
                />
              </TextButton>
            </div>
          </Group>
        </LayoutContainer>
      </ContentContainer>
    </StyledSheet>
  )
}

export default TripLandingPageFooter
